/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListContractTemplatesRequest = {
  properties: {
    hirerId: {
      type: 'string',
    },
  },
} as const;
